module.exports = __webpack_public_path__ + "images/icon/radio_on-31c77c25.svg";